(function(){
  function refreshBuyNow(root){
    if(!root) return;
    var select=root.querySelector('[data-variant-select]');
    var hidden=root.querySelector('.cs2-product-form input[name="id"]');
    var qty=root.querySelector('.cs2-product-form input[name="quantity"]');
    var variantId=select ? select.value : (hidden ? hidden.value : '');
    var available=true;
    if(select && select.selectedOptions && select.selectedOptions[0]) available=select.selectedOptions[0].dataset.available !== 'false';
    root.querySelectorAll('[data-buy-now]').forEach(function(link){
      if(!select) available=link.dataset.currentAvailable !== 'false';
      var quantity=Math.max(1,parseInt(qty ? qty.value : '1',10)||1);
      if(variantId && available){link.href=link.dataset.cartRoot+'/'+variantId+':'+quantity+'?checkout';link.classList.remove('is-disabled');link.setAttribute('aria-disabled','false');}
      else{link.href='#';link.classList.add('is-disabled');link.setAttribute('aria-disabled','true');}
    });
  }
  function init(scope){(scope||document).querySelectorAll('[data-product-root]').forEach(refreshBuyNow);}
  if(!window.__clicksubsBuyNowBound){
    window.__clicksubsBuyNowBound=true;
    document.addEventListener('change',function(e){if(e.target.matches('[data-variant-select],.cs2-qty')) refreshBuyNow(e.target.closest('[data-product-root]'));});
    document.addEventListener('click',function(e){
      var pill=e.target.closest('[data-variant-pill]');
      if(pill){setTimeout(function(){refreshBuyNow(pill.closest('[data-product-root]'));},0);}
      var buy=e.target.closest('[data-buy-now]');
      if(buy && buy.classList.contains('is-disabled')) e.preventDefault();
    });
    document.addEventListener('shopify:section:load',function(e){init(e.target);});
  }
  init(document);
})();
